module.exports = __webpack_public_path__ + "img/353.7409ef3c.svg";